<template>
	<div class="df1" v-loading.fullscreen.lock="loading">
		<el-form ref="form" :model="form" :rules="rules"  
		              label-position="top">
					 
			<el-form-item label="名字" prop="name" > 
				<el-input v-model="form.name" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="邮件" prop="eMail">
				<el-input v-model="form.eMail" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="签约主体所在地" prop="country">
				 <el-input v-model="form.country" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="公司类型" prop="companyType">
				<el-select v-model="form.companyType" placeholder=""  filterable     :style="{width: '100%'}" :popper-append-to-body="false" >
					<el-option v-for="(item, index) in companyTypeOption" :key="index" :label="item.label"
							   :value="item.value" ></el-option>
				 </el-select>
			</el-form-item> 
			<el-form-item label="曲库歌曲数量?" prop="trackCount">
				 <el-input v-model="form.trackCount" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="主要音乐类型" prop="musicType">
				<el-select v-model="form.musicType" placeholder=""  filterable     :style="{width: '100%'}" :popper-append-to-body="false" >
					<el-option v-for="(item, index) in musicTypeOption" :key="index" :label="item.label"
							   :value="item.value" ></el-option>
				 </el-select>
			</el-form-item> 
			<el-form-item label="" prop="originalSong">
				原创歌曲
				<el-radio-group v-model="form.originalSong">
				    <el-radio label="yes">yes</el-radio>
				    <el-radio label="no">no</el-radio>
				</el-radio-group>
			</el-form-item> 
			<el-form-item label="音频语言" prop="audioLanguage">
				<el-select v-model="form.audioLanguage" placeholder=""  filterable     :style="{width: '100%'}" :popper-append-to-body="false" >
					<el-option v-for="(item, index) in audioLanguageOption" :key="index" :label="item.label"
							   :value="item.value" ></el-option>
				 </el-select>
			</el-form-item> 
			
			
			<el-form-item label="现合作发行商，不再继续合作原因" prop="arrangement">
				 <el-input v-model="form.arrangement" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="从哪些聚道了解到EWWAY的?" prop="know">
				 <el-input v-model="form.know" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="希望EWWAY在哪些方面帮到你?" prop="hope">
				 <el-input v-model="form.hope" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="你的艺术家在流媒体平台主页（YouTube, Spotify, Apple Music等）" prop="artist">
				<span class="labelSpan" style="left: 425px;"> 在列举多个项目或元素时，使用逗号进行分隔</span>
				 <el-input v-model="form.artist" placeholder="" type="textarea" 
						resize="none"    :autosize="{ minRows: 4 }" ></el-input>
			</el-form-item> 
			<el-form-item label="想要发行的地区" prop="regions">
				 <el-input v-model="form.regions" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="想要发行的平台" prop="dsp">
				 <el-input v-model="form.dsp" placeholder="" ></el-input>
			</el-form-item> 
			
			
			<el-form-item label="情况描述"  prop="description">
			  <el-input v-model="form.description" type="textarea" 
						resize="none"    :autosize="{ minRows: 4 }" ></el-input>
			</el-form-item>
			<el-form-item label="" prop="check1">
			  <el-checkbox v-model="form.check1" ></el-checkbox>
			  <span class="checkBoxClass" >我们尤为注重版权问题，并且坚持严格的反欺诈政策。要通过EWWAY分发内容，必须拥有内容的完整著作权。如果出现与版权相关的任何问题，我们将立即删除内容。感谢您的理解！</span><br>
			</el-form-item>
			
			 <el-button type="primary" @click="add">提交</el-button>
					
		</el-form>
		
	</div>
	
</template>

<script>
import axios from 'axios';
export default {
	name : "Form1",
	data() {
		return {
			companyTypeOption:[{"label":"独立音乐人","value":"独立音乐人"},
							{"label":"唱片公司","value":"唱片公司"},
							{"label":"经纪公司","value":"经纪公司"},
							{"label":"分销商/聚合商","value":"分销商/聚合商"},
							{"label":"艺人服务平台","value":"艺人服务平台"},
							{"label":"其他","value":"其他"},
							],
			musicTypeOption:[{"label":"人声音乐","value":"人声音乐"},{"label":"非人声音乐","value":"非人声音乐"}],
			audioLanguageOption:[
							{"label":"中文","value":"中文"},
							{"label":"英文","value":"英文"},
							{"label":"日语","value":"日语"},
							{"label":"韩语","value":"韩语"},
							{"label":"越南语","value":"越南语"},
							{"label":"印度语","value":"印度语"},
							{"label":"其他","value":"其他"},
							],
			form:{
				originalSong : "yes"
			},
			rules:{
				name: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				eMail: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				country: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				companyType: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				trackCount: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				musicType: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				audioLanguage: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				arrangement: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				know: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				hope: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				artist: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				regions: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				dsp: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				check1: [
				  { required: true, message: "必选", trigger: ["blur","change"] }
				]
			},
			loading:false
		}
	},
	methods:{
		
		add(){
			this.$refs["form"].validate(valid => {
				if (valid) {
					this.loading = true
					axios.post('https://cms.ewway.com/ewway-api/feedback/distribution', this.form)
						.then(response => {
							this.loading = false
						  // 处理返回的数据
						  if(response.data.code===200){
							 this.$message({
							 							type: 'success',
							 							message: "提交成功！我们将尽快处理并回复您的消息，衷心感谢您对我们的关注与支持！",
							 							customClass :'customClass',
							 							duration:2000,
							 }); 
							 this.$refs['form'].resetFields();
						  }else{
							  this.$message({
							  							type: 'error',
							  							message: "提交失败！",
							  							customClass :'customClass',
							  							duration:2000,
							  });
						  }
						  
						})
						.catch(error => {
						  console.error(error);
							this.loading = false
						  // 错误处理逻辑
						  this.$message({
									type: 'error',
									message: "提交失败！",
									customClass :'customClass',
									duration:2000,
						  });
						});
				}
					
			});
		}
	}
}
	
	
</script>

<style >
	.df1{
		width:80%;
		margin-left:10%;
		text-align: left;
	}
	.customClass{
		font-size:12px;
	}
	.labelSpan{
		position: absolute;
		top: -50px;
		font-size: 12px;
		color: #A5A3BE;
	}
</style>